import React from 'react';
import { OnboardingStep } from '../../components/OnboardingTour';

export const PAIR_ONBOARDING_KEY = 'onboarding:pair:v2';

/** Shown on the spread chart by the guide when the basket is still empty; never added. */
export const PAIR_ONBOARDING_DEMO_STOCK = 'VNM';

export const pairOnboardingSteps = (opts: {
    spreadDemo: { start: () => void; stop: () => void };
}): OnboardingStep[] => [
    {
        title: 'Welcome to Pair Trading',
        description: (
            <>
                <p>A pair hedges a futures contract against a basket of stocks: one leg SHORT, the other LONG. By default the bot opens right after Start, up to Max Open Positions, and closes each pair on take-profit or stop-loss.</p>
                <p style={{ marginBottom: 0 }}>Setup: <b>mode → future → stock basket → rules → Save → Deposit → Start</b>.</p>
            </>
        ),
    },
    {
        selector: '[data-testid="pair-switcher-bar"]',
        title: 'Your pairs',
        description: 'Each tab is one pair on this portfolio. Use New pair to create another.',
        placement: 'bottom',
    },
    {
        selector: '[data-tour="pair-chart"]',
        title: 'Legs and spread',
        description: (
            <>
                <p style={{ marginBottom: 0 }}>The <b>View</b> chart. Top: one futures contract against your basket, both in ₫. Bottom: the spread, futures ÷ basket − 1, measured from the previous close (ATC). The Spread readout on the right uses the same basket.</p>
            </>
        ),
        placement: 'right',
        onEnter: opts.spreadDemo.start,
        onLeave: opts.spreadDemo.stop,
    },
    {
        selector: '[data-tour="pair-entry"]',
        title: '1. Mode',
        description: (
            <>
                <p><b>Auto</b>: the bot opens pairs one at a time right after Start. No target prices needed.</p>
                <p style={{ marginBottom: 0 }}><b>Waiting</b>: you enter a Target Price on every leg, and the bot opens only while the Reference PnL is negative. Locked while the bot runs.</p>
            </>
        ),
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-future"]',
        title: '2. Futures leg',
        description: 'The futures contract the pair trades against your basket: one contract per pair.',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-equity"]',
        title: '3. Stock basket',
        description: 'Click ADD to put a stock in the basket, then set its Weight (its share of one pair; weights add up to 1).',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-open"]',
        title: '4. Opening',
        description: 'Max Open Positions caps how many pairs the bot opens in total; a closed pair does not free its slot. The pair ends as soon as no pair is open, even if the cap has not been reached. Pause Opening stops new opens without stopping the bot.',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-exit"]',
        title: '5. Closing',
        description: 'A pair closes at TP (%) or SL (%), or after Max Holding Days (0 = off). Close All closes every open pair now.',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-save"]',
        title: '6. Save',
        description: 'Saves the settings. No orders are placed and no money moves.',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-cash"]',
        title: '7. Deposit',
        description: 'Pick the derivatives account, then deposit cash. It is split across both legs.',
        placement: 'left',
    },
    {
        selector: '[data-tour="pair-run"]',
        title: '8. Start',
        description: 'Starts the bot once both legs are funded. Stop the bot before depositing or withdrawing. Click Guide at the top right to replay this tour.',
        placement: 'left',
    },
];
